import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { APP_CONFIG } from '@valk-nx/content/app/config/config';
import { environment } from '@valk-nx/content/environments/environment';
import { getContentConfigurationKey } from '@valk-nx/core/lib/ssr/ssr.helper';
import { DocumentLangHelper } from '@valk-nx/helpers/lib/document-lang/document-lang.helper';

import { AppComponent } from './app/app.component';
import { appConfig, CONTENT_APP_ID } from './app/app.config';
import { getStoryblokQueryParams } from './app/helpers/storyblok-params.helper';

DocumentLangHelper.setFromUrl(globalThis?.location?.pathname);

if (environment.production) {
	enableProdMode();
}

// Check if the page is being rendered by the server by looking for the presence of the server-injected state element.
const hasServerState = !!document.getElementById(`${CONTENT_APP_ID}-state`);

if (hasServerState) {
	bootstrapApplication(AppComponent, appConfig).catch((err) =>
		console.error(err),
	);
} else {
	const key = getContentConfigurationKey(globalThis.location.host);
	const storyblokQueryParams = getStoryblokQueryParams(
		new URLSearchParams(globalThis.location.search),
	);

	// Allow sending cookies (e.g. session/auth) with cross-origin API requests
	// when explicitly enabled in the environment.
	fetch(
		`${environment.apiUrl}content-config?host=${key}${storyblokQueryParams}`,
		{
			credentials: environment?.withCredentials
				? 'include'
				: 'same-origin',
		},
	)
		.then((resp) => resp.json())
		.then((config) => {
			// Overrides the TransferState-backed APP_CONFIG provider (last
			// provider wins) with the freshly fetched config.
			appConfig.providers.push({
				provide: APP_CONFIG,
				useValue: config.data,
			});
			return bootstrapApplication(AppComponent, appConfig);
		})
		.catch((err) => console.error(err));
}
